import React from 'react';
  


interface IProps {
  onClick ?: () => void;
  style?:any;
}
const ProfileUploadIcon = ({onClick, style} :IProps) => {
  return (
<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_316_14573)">
<path d="M16.7209 1.56055H7.08716V5.55556H18.7784V3.61726C18.7784 2.48308 17.8554 1.56055 16.7209 1.56055Z" fill="#CED9F9"/>
<path d="M11.2676 6.17013H0V2.46318C0 1.10486 1.10534 0 2.46414 0H6.06679C6.42487 0 6.76982 0.0754623 7.08321 0.217255C7.52092 0.414482 7.89695 0.739563 8.16067 1.1643L11.2676 6.17013Z" fill="#1640C1"/>
<path d="M21 7.00018V18.9409C21 20.0765 20.0755 21.0001 18.9394 21.0001H2.06055C0.924454 21.0001 0 20.0765 0 18.9409V4.94043H18.9394C20.0755 4.94043 21 5.8644 21 7.00018Z" fill="#2354E6"/>
<path d="M21 7.00018V18.9409C21 20.0765 20.0755 21.0001 18.9394 21.0001H10.5V4.94043H18.9394C20.0755 4.94043 21 5.8644 21 7.00018Z" fill="#1849D6"/>
<path d="M16.024 12.9703C16.024 16.0165 13.5459 18.4947 10.5 18.4947C7.45415 18.4947 4.97607 16.0165 4.97607 12.9703C4.97607 9.92453 7.45415 7.44629 10.5 7.44629C13.5459 7.44629 16.024 9.92453 16.024 12.9703Z" fill="#E7ECFC"/>
<path d="M16.024 12.9703C16.024 16.0165 13.5459 18.4947 10.5 18.4947V7.44629C13.5459 7.44629 16.024 9.92453 16.024 12.9703Z" fill="#CED9F9"/>
<path d="M12.2806 13.0379C12.1654 13.1355 12.0243 13.1831 11.8844 13.1831C11.7093 13.1831 11.5353 13.1089 11.4135 12.9644L11.1153 12.6109V14.9249C11.1153 15.2646 10.8398 15.5402 10.5001 15.5402C10.1605 15.5402 9.88488 15.2646 9.88488 14.9249V12.6109L9.58671 12.9644C9.36721 13.2241 8.97933 13.2572 8.71962 13.0379C8.46006 12.8189 8.42674 12.4308 8.64576 12.1711L9.86357 10.7274C10.0223 10.5396 10.254 10.4316 10.5001 10.4316C10.7462 10.4316 10.9779 10.5396 11.1367 10.7274L12.3545 12.1711C12.5735 12.4308 12.5402 12.8189 12.2806 13.0379Z" fill="#6C8DEF"/>
<path d="M12.2805 13.0379C12.1653 13.1355 12.0241 13.1831 11.8843 13.1831C11.7092 13.1831 11.5352 13.1089 11.4134 12.9644L11.1152 12.6109V14.9249C11.1152 15.2646 10.8397 15.5402 10.5 15.5402V10.4316C10.7461 10.4316 10.9778 10.5396 11.1365 10.7274L12.3544 12.1711C12.5734 12.4308 12.54 12.8189 12.2805 13.0379Z" fill="#3B67E9"/>
</g>
<defs>
<clipPath id="clip0_316_14573">
<rect width="21" height="21" fill="white"/>
</clipPath>
</defs>
</svg>
  );
};

export default ProfileUploadIcon;